import { LockClosedIcon, LockOpenIcon } from "@heroicons/react/24/outline";
import { cx } from "../../utils/cx";
import { Switch } from "../ui";

// One institution's loan request status, with a switch to open or close it
export default function LoanStatusRow({ name, open, loading = false, disabled = false, onChange }) {
  return (
    <li className="flex items-center justify-between gap-4 px-5 py-4">
      <div className="flex min-w-0 items-center gap-3">
        <span className={cx("flex h-9 w-9 shrink-0 items-center justify-center rounded-lg", open ? "bg-green-50 text-green-600" : "bg-slate-100 text-slate-500")}>
          {open ? <LockOpenIcon className="h-4 w-4" /> : <LockClosedIcon className="h-4 w-4" />}
        </span>
        <div className="min-w-0">
          <p className="truncate font-medium text-slate-900">{name}</p>
          <p className="text-sm text-slate-500">{open ? "Accepting loan requests" : "Loan requests closed"}</p>
        </div>
      </div>
      <Switch checked={open} loading={loading} disabled={disabled} label={`Loan requests for ${name}`} onChange={onChange} />
    </li>
  );
}
